import { ICurrency } from '@/evercall/domain/vo/Currency';
import { ICurrencyOption } from './interfaces';

export const mapCurrencyToOption = (currency: ICurrency): ICurrencyOption => (
  {
    value: currency.id,
    label: currency.displayName,
    currencySymbol: currency.abbreviation,
    countryCode: currency.flagDisplayName,
  }
);
